export const demoEdgeMockPlazaDetails = {
  'plaza-001': {
    name: 'Downtown Charging Hub',
    address: '123 Main St, New York, NY 10001',
    totalChargers: 4,
    availableChargers: 2,
    algorithm: 'Schedule Driven Load Mgmt',
  },
  'plaza-002': {
    name: 'Airport Plaza Station',
    address: '456 Airport Blvd, Los Angeles, CA 90045',
    totalChargers: 3,
    availableChargers: 2,
    algorithm: 'Adaptive Load Management',
  },
  'plaza-003': {
    name: 'Shopping Mall Station',
    address: '789 Shopping Center Dr, Chicago, IL 60611',
    totalChargers: 2,
    availableChargers: 0,
    algorithm: 'Schedule Driven Load Mgmt',
  },
  'plaza-004': {
    name: 'City Center Station',
    address: '321 Downtown Ave, Houston, TX 77002',
    totalChargers: 3,
    availableChargers: 1,
    algorithm: 'Adaptive Load Management',
  },
  'plaza-005': {
    name: 'Highway Rest Stop',
    address: 'I-95 Mile Marker 45, Philadelphia, PA 19019',
    totalChargers: 2,
    availableChargers: 1,
    algorithm: 'Schedule Driven Load Mgmt',
  },
  'plaza-006': {
    name: 'University Campus Station',
    address: '555 College Rd, San Antonio, TX 78249',
    totalChargers: 4,
    availableChargers: 2,
    algorithm: 'Adaptive Load Management',
  },
  'plaza-007': {
    name: 'Residential Complex',
    address: '888 Apartment Way, Dallas, TX 75201',
    totalChargers: 2,
    availableChargers: 2,
    algorithm: 'Schedule Driven Load Mgmt',
  },
  'plaza-008': {
    name: 'Train Station Plaza',
    address: '999 Railroad St, Austin, TX 78701',
    totalChargers: 3,
    availableChargers: 2,
    algorithm: 'Adaptive Load Management',
  },
};
